// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"a90e4b5c","359":"3ecf9222","945":"cc66f2e2"}[chunkId] + ".chunk.js";
};